var React = require('react');

function Database (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M26 17.332C36.7696 17.332 45.5 14.4219 45.5 10.832C45.5 7.24218 36.7696 4.33203 26 4.33203C15.2304 4.33203 6.5 7.24218 6.5 10.832C6.5 14.4219 15.2304 17.332 26 17.332Z","stroke":"#EFA5DF","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M45.5 26C45.5 29.5967 36.8333 32.5 26 32.5C15.1667 32.5 6.5 29.5967 6.5 26","stroke":"#EFA5DF","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M6.5 10.832V41.1654C6.5 44.762 15.1667 47.6654 26 47.6654C36.8333 47.6654 45.5 44.762 45.5 41.1654V10.832","stroke":"#EFA5DF","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

Database.defaultProps = {"width":"52","height":"52","viewBox":"0 0 52 52","fill":"none"};

module.exports = Database;

Database.default = Database;
